module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminlistados-eventos/adminlistados-eventos.component.scss
// module id = ./src/app/adminlistados-eventos/adminlistados-eventos.component.scss
// module chunks = main